export default __webpack_public_path__ + "static/media/icon-HS-sig.b24dee45.png";